import { FloatingPortal } from '@floating-ui/react';
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const GroupFrame = /* @__PURE__ */ __name(({
  children,
  getFloatingProps,
  isOpen,
  refs,
  strategy,
  x,
  y
}) => /* @__PURE__ */ React.createElement(FloatingPortal, null, /* @__PURE__ */ React.createElement(AnimatePresence, null, isOpen && /* @__PURE__ */ React.createElement(motion.div, {
  animate: { opacity: 1, translateY: 0 },
  className: "mds-tag-overflow-dropdown",
  exit: { opacity: 0, translateY: -16 },
  initial: { opacity: 0, translateY: -16 },
  ref: refs.setFloating,
  style: {
    position: strategy,
    top: y != null ? y : 0,
    left: x != null ? x : 0,
    width: "max-content"
  },
  transition: { type: "keyframes", duration: 0.1 },
  ...getFloatingProps()
}, children))), "GroupFrame");

export { GroupFrame };
//# sourceMappingURL=group-frame.js.map
